import React from 'react';
import {LISTICON, MAPICON} from '../../../components/svg-def';
import {SVGIcon} from '@homeaway/react-svg';
import classnames from 'classnames';

export function Tab({icon, langText}) {
    return (
        <span>
            <SVGIcon
                className="map-navigation__icon"
                markup={icon}
            />
            {langText}
        </span>
    );
}

export const ListTab = ({langText}) => (<Tab icon={LISTICON} langText={langText} />);
export const MapTab = ({langText}) => (<Tab icon={MAPICON} langText={langText} />);

export function TabNavigation(props) {
    const {mapTestValue, displayIndex, translations, onTabClick} = props;

    const navTabClass0 = classnames('map-navigation__a', {
        'map-navigation__a--active': displayIndex === 0
    });

    const navTabClass1 = classnames('map-navigation__a', {
        'map-navigation__a--active': displayIndex === 1
    });

    // default variant 1
    let firstButtonText = translations.listText;
    let secondButtonText = translations.mapText;
    let FirstTab = <ListTab langText={firstButtonText} />;
    let SecondTab = <MapTab langText={secondButtonText} />;

    // reverse tab order for variant 2
    if (mapTestValue === 2) {
        firstButtonText = translations.mapText;
        secondButtonText = translations.listText;
        FirstTab = <MapTab langText={firstButtonText} />;
        SecondTab = <ListTab langText={secondButtonText} />;
    }

    function handleTabClick(idx) {
        return () => {
            onTabClick(idx);
        };
    }

    return (
        <div className="row">
            <ul className="map-navigation__ul">
                <li className="map-navigation__li" >
                    <button
                        aria-label={firstButtonText}
                        onClick={handleTabClick(0)}
                        className={navTabClass0}
                    >
                        {FirstTab}
                    </button>
                </li>
                <li className="map-navigation__li">
                    <button
                        aria-label={secondButtonText}
                        onClick={handleTabClick(1)}
                        className={navTabClass1}
                    >
                        {SecondTab}
                    </button>
                </li>
            </ul>
        </div>
    );
}

TabNavigation.defaultProps = {
    mapTestValue: 0,
    displayIndex: 0,
    translations: {}
};

export default TabNavigation;



// WEBPACK FOOTER //
// ./src/universal/tripboard/details/components/tab-navigation.js